module.exports = __webpack_public_path__ + "static/media/host-register-success.61b941ec.png";